import { useEffect, useContext } from 'react';
import Cookies from 'universal-cookie';
import { v4 as uuidV4 } from 'uuid';

import siftPageView from 'helpers/siftScience';

import { CustomerContext } from 'context/customer';

import CN_SIFT_SCIENCE_COOKIE from 'helpers/config';

export default function usePageviewAnalytics() {
  const { user } = useContext(CustomerContext);

  function fireSiftPageView() {
    const cookies = new Cookies();
    let siftScienceCookie = cookies.get(CN_SIFT_SCIENCE_COOKIE);
    if (!siftScienceCookie) {
      siftScienceCookie = uuidV4();
      cookies.set(CN_SIFT_SCIENCE_COOKIE, siftScienceCookie);
    }
    siftPageView(siftScienceCookie, user?.id);
  }

  useEffect(() => {
    fireSiftPageView();
  }, []);
}
